import React, { Component } from 'react'
import axios from 'axios'
import { backendUrl } from '../../Services/backend-url'
import { getAmount } from '../../Services/util-functions'
import InputButton from '../Design/InputButton'

export default class EditSavings extends Component {
  state = {
    amount: getAmount(this.props.savings.amount),
    username: this.props.savings.username,
    id: this.props.savings._id
  }

  handleAmountChange = e => {
    this.setState({ amount: e.target.value })
  }

  handleSubmit = e => {
    e.preventDefault()

    axios.post(backendUrl + 'savings/edit', this.state)
      .then(res => this.props.onHandleNewSavings(res.data))
  }

  render() {
    return (
      <div className='account-overview-card-form fade-in'>
        <form className='mb' onSubmit={this.handleSubmit}>
          <title>Edit Savings</title>
          <label htmlFor='amount'>Amount: </label>
          <input className='font75 block mb' type='text' id='amount' value={this.state.amount} name='amount' onChange={this.handleAmountChange} />
          <InputButton addClass='button-1 font75 mt' inputType='submit' text='Submit' />
        </form>
        <p className='font50 mt pointer' onClick={() => this.props.onHandleEdit(false, 'Savings')}> Cancel </p>
      </div>
    )
  }
}
